import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getAppVersion,
  accountId,
} from '../util';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { FeedbackModal } from './modals';
import { getIcon } from '../util/icons';

class Footer extends Component {

  state = {
    showingFeedbackModal: false,
  }

  renderLogo(){
    const { logoUrl } = this.props.organization || {};

    if(!logoUrl){
      return null;
    }

    return (
      <img className="footer-logo" src={logoUrl} />
    )
  }

  renderFeedbackModal(){
    return <FeedbackModal
      visible={this.state.showingFeedbackModal}
      hide={() => { this.setState({ showingFeedbackModal: false }); }}
    />;
  }

  renderVersionNumber(){
    return (
      <CopyToClipboard options={{format: "text/plain"}} text={accountId()}>
        <div className="app-version">{getAppVersion()}</div>
      </CopyToClipboard>
    )
  }

  showFeedbackCollect(){
    this.setState({
      showingFeedbackModal: true
    });
  }

  renderLeaveFeedbackButton(){

    if(!accountId()){
      return null;
    }

    return(
      <div onClick={() => { this.showFeedbackCollect() }} className="app-feedback">{getIcon('chat')} Submit Feedback</div>
    )
  }

  render(){

    return (
      <footer className={'footer' + (accountId() ? ' tall' : '')}>
        <div className="content-wrapper">
          {this.renderVersionNumber()}
          {this.renderLogo()}
          {this.renderLeaveFeedbackButton()}
        </div>

        {this.renderFeedbackModal()}
      </footer>
    )
  }
}

function mapStateToProps(state){
  return {
    organization: state.organization.data,
    myTeams: state.myTeams.data
  }
}

export default connect(mapStateToProps, {})(Footer);



// WEBPACK FOOTER //
// ./src/components/footer.js